/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { IconButton } from '@material-ui/core';
import './carrusel.css'

export default function Carusel() {
  const arrowStyles = {
    position: 'absolute',
    zIndex: 2,
    top: 'calc(50% - 15px)',
    width: 40,
    height: 40,
    cursor: 'pointer',
  };
  const [listaImagenes, setListaImagenes] = useState([]);


  async function getAllFiles() {
    const images = require.context('./images/', true);
    const imageList = images.keys().map(image => images(image));
    setListaImagenes(imageList)
  }

  useEffect(() => {
    getAllFiles()
  }, []);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundRepeat: 'no-repeat',
    }}>
      <div
        style={{
          width: '80%',
        }}
      >
        <Carousel
          autoPlay
          infiniteLoop
          showStatus={false}
          showThumbs={false}
          renderArrowPrev={(onClickHandler, hasPrev, label) =>
            hasPrev && (
              <IconButton
                aria-label='prev'
                title={label}
                style={{ ...arrowStyles, left: 15, color: '#bb823f' }}
                onClick={onClickHandler}
              >
                <ArrowBackIosIcon fontSize='large' />
              </IconButton>
            )
          }
          renderArrowNext={(onClickHandler, hasNext, label) =>
            hasNext && (
              <IconButton
                aria-label='next'
                title={label}
                style={{ ...arrowStyles, right: 15, color: '#bb823f' }}
                onClick={onClickHandler}
              >
                <ArrowForwardIosIcon fontSize='large' />
              </IconButton>
            )
          }
        >
          {listaImagenes.map((imagen, index) =>
            <div key={`img${index}`}>
              <img alt={`img${imagen}`} style={{ maxWidth: 500 }} src={imagen} />
            </div>
          )}
        </Carousel >
      </div>
    </div >
  );
}
